export class HAxis {
    maxValue?: number;
    title?: string;
    showEveryText?:number;
    textPosition?:string;
    direction?:number;
    viewWindow?:any;
    slantedText?:boolean;
}
